import React from 'react';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

import { useFreecodeContext, useAppContext } from 'hooks/useContext';
import { Checkbox } from 'components/Checkbox/Checkbox';
import { CategoryDropdown } from 'components/FreecodeContent/FreecodeButtons';
import { categories, userRoles } from 'util/appConstants';
import { LanguageHeader } from './styles';
import { Title, FormSection, NumberInput, Label, InputContainer } from '../../styles';

export default function FreecodeTestCases() {
  const { isDarkMode } = useAppContext();
  const { test, testImpl, languageData } = useFreecodeContext();
  const { userRole } = useSelector((state) => state.auth);

  const updateNumberOfTestCases = (parameter, value) => {
    console.log('tried to set test cases ', parameter, value);
    toast.error('Not implemented');
  };

  const handlePerformanceScoreChange = (language, index, value) => {
    console.log('tried update performance test case  ', language, index, value);
    toast.error('Not implemented');
  };

  const renderPerformanceScoresSection = () => {
    return (
      <FormSection>
        <Title>Good performance scores</Title>
        {Object.keys(languageData || {}).map((language, languageIndex) => (
          <React.Fragment key={languageIndex}>
            <LanguageHeader>{languageData[language]?.SimpleName || language}</LanguageHeader>
            {[...Array(testImpl.configLevels.numPerformance).keys()].map((perfKey) => (
              <InputContainer key={perfKey}>
                <Label nowrap>Performance score {perfKey + 1}:</Label>
                <NumberInput
                  value={testImpl.configLevels.goodPerformanceScores?.[language]?.[perfKey]}
                  onChange={(e) => handlePerformanceScoreChange(language, perfKey, e.target.value)}
                />
              </InputContainer>
            ))}
          </React.Fragment>
        ))}
      </FormSection>
    );
  };

  return (
    <>
      <FormSection>
        <Title>Test case levels</Title>
        {userRole === userRoles.SUPER_ADMIN && (
          <InputContainer>
            <Label nowrap>Category:</Label> <CategoryDropdown />
          </InputContainer>
        )}
        {test.category === categories.CHALLENGE.category && (
          <InputContainer>
            <Checkbox
              isDarkMode={isDarkMode}
              checked={test.isTournament}
              label="Is Tournament"
              title="In a tournament solutions compete against each other"
              onChange={() => toast.error('Not Implemented')} // TODO Implement
            />
          </InputContainer>
        )}
        {test.category === categories.EXERCISE.category && (
          <InputContainer>
            <Checkbox
              isDarkMode={isDarkMode}
              checked={test.isFreecode}
              label="Is Freecode"
              title='A freecode exercise might be a demonstration without a "solution"'
              onChange={() => toast.error('Not Implemented')} // TODO Implement
            />
          </InputContainer>
        )}
        <InputContainer>
          <Label nowrap>Number of public levels:</Label>
          <NumberInput
            value={testImpl.configLevels.numPublic}
            onChange={(e) => updateNumberOfTestCases('numPublic', e.target.value)}
          ></NumberInput>
        </InputContainer>
        {test.category !== categories.EXERCISE.category && (
          <InputContainer>
            <Label nowrap>Number of hidden levels:</Label>
            <NumberInput
              value={testImpl.configLevels.numHidden}
              onChange={(e) => updateNumberOfTestCases('numHidden', e.target.value)}
            ></NumberInput>
          </InputContainer>
        )}
        {test.category === categories.CODE.category && (
          <InputContainer>
            <Label nowrap>Number of performance levels:</Label>
            <NumberInput
              value={testImpl.configLevels.numPerformance}
              onChange={(e) => updateNumberOfTestCases('numPerformance', e.target.value)}
            ></NumberInput>
          </InputContainer>
        )}
      </FormSection>
      {test.category === categories.CODE.category &&
        testImpl.configLevels?.numPerformance &&
        renderPerformanceScoresSection()}
    </>
  );
}
